import { Controller } from "@hotwired/stimulus"

// Drives the deep-link entry into the activity feed (`/activity?at=123`): scrolls
// the targeted activity into view and flashes it, and keeps the scroll position
// stable when "Load newer" prepends activities above the current viewport.
// The controller element is the scrollable feed container.
export default class extends Controller {
  static values = { id: String }

  connect() {
    if (this.idValue) requestAnimationFrame(() => this.scrollToAnchor())
    this.watchPrepends()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  scrollToAnchor() {
    // Match the row by its own id, or a bundled burst card carrying it as a member.
    const el = this.element.querySelector(
      `#activity-${CSS.escape(this.idValue)}, [data-activity-ids~="${CSS.escape(this.idValue)}"]`,
    )
    if (!el) return

    el.scrollIntoView({ block: "center", behavior: "auto" })
    el.style.transition = "background-color 0.4s ease"
    el.style.borderRadius = "10px"
    el.style.backgroundColor = "rgba(106, 0, 255, 0.06)"
    setTimeout(() => {
      el.style.backgroundColor = ""
    }, 1800)
  }

  // "Load newer" prepends rows above the viewport. Add each newly inserted row's
  // height to scrollTop so the row the user was reading stays put (no jump).
  // A MutationObserver avoids any reliance on stream-render timing.
  watchPrepends() {
    const newerBox = this.element.querySelector("#activity_items_newer")
    if (!newerBox) return

    this.observer = new MutationObserver((mutations) => {
      let added = 0
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) added += node.offsetHeight
        }
      }
      if (added) this.element.scrollTop += added
    })
    this.observer.observe(newerBox, { childList: true })
  }
}
